module.exports = __webpack_public_path__ + "static/media/menu-close-icon.1823835a.svg";